import type { TranslationKey } from "./ko.js";

export const ja: Record<TranslationKey, string> = {
  // Common
  "app.name": "ooo.codes",
  "app.subtitle": "URL短縮 & QRコード生成",
  "common.loading": "読み込み中...",
  "common.cancel": "キャンセル",
  "common.save": "保存",
  "common.delete": "削除",
  "common.copy": "コピー",
  "common.copied": "コピー済み",

  // Login
  "login.title": "パスキーでログイン",
  "login.button": "パスキーでログイン",
  "login.authenticating": "認証中...",
  "login.passkey_info": "このサービスはパスキー（WebAuthn）によるパスワードレス認証を使用しています。",
  "login.first_time": "初めてですか？アカウントを設定してください",
  "login.have_invite": "招待コードをお持ちですか？",
  "login.invite_placeholder": "招待コードを入力",
  "login.join": "参加",
  "login.back_to_login": "ログインに戻る",
  "login.auth_cancelled": "認証がキャンセルされたか、許可されませんでした。",
  "login.failed": "ログインに失敗しました",
  "login.or": "または",
  "login.signup_button": "新規登録",
  "login.signup_title": "アカウント作成",
  "login.signup_subtitle": "パスキーで簡単に登録できます。",
  "login.usage_today": "本日のリクエスト",
  "login.used": "使用済み",
  "login.pending_approval": "管理者の承認待ちです。承認後にログインできます。",
  "login.account_suspended": "アカウントが一時停止されています。管理者にお問い合わせください。",
  "login.account_banned": "アカウントがブロックされています。",
  "login.signup_success": "登録が完了しました！管理者の承認後にログインできます。",

  // Setup
  "setup.title": "ようこそ！アカウントを設定してください",
  "setup.subtitle": "オーナーアカウントを作成して開始します。",
  "setup.username": "ユーザー名",
  "setup.display_name": "表示名",
  "setup.button": "パスキーでアカウント作成",
  "setup.setting_up": "設定中...",
  "setup.already_have_account": "アカウントをお持ちですか？ログイン",
  "setup.cancelled": "登録がキャンセルされたか、許可されませんでした。",
  "setup.failed": "設定に失敗しました",

  // Invite
  "invite.verifying": "招待を確認中...",
  "invite.invalid_title": "無効または期限切れの招待",
  "invite.invalid_message": "この招待リンクは無効です。管理者に新しい招待を依頼してください。",
  "invite.invited": "招待されました",
  "invite.create_account": "アカウントを作成",
  "invite.for": "招待先：",
  "invite.username": "ユーザー名",
  "invite.username_placeholder": "ユーザー名を選択",
  "invite.display_name": "表示名",
  "invite.display_name_placeholder": "お名前",
  "invite.button": "パスキーでアカウント作成",
  "invite.setting_up": "設定中...",
  "invite.passkey_info": "パスワードレス認証のためのパスキー作成が求められます。",
  "invite.cancelled": "登録がキャンセルされたか、許可されませんでした。",
  "invite.failed": "登録に失敗しました",

  // Invitations
  "invitations.title": "招待管理",
  "invitations.send": "招待を送信",
  "invitations.email_placeholder": "メールアドレスを入力",
  "invitations.send_button": "招待を送信",
  "invitations.sending": "送信中...",
  "invitations.list_title": "招待一覧",
  "invitations.empty": "まだ招待がありません。",
  "invitations.status_pending": "保留中",
  "invitations.status_accepted": "承認済み",
  "invitations.status_expired": "期限切れ",
  "invitations.copy_link": "リンクをコピー",
  "invitations.revoke": "取消",
  "invitations.revoke_confirm": "この招待を取り消しますか？",
  "invitations.created": "作成日",
  "invitations.expires": "有効期限",
  "invitations.owner_only": "招待管理はオーナーのみ利用できます。",

  // Create Link
  "create.advanced_settings": "詳細設定",
  "create.qr_preview": "QRコードプレビュー",
  "create.default_expiry_info": "デフォルト有効期限：7日",

  // Navigation
  "nav.dashboard": "ダッシュボード",
  "nav.create_link": "リンク作成",
  "nav.invitations": "招待管理",
  "nav.settings": "設定",
  "nav.logout": "ログアウト",
  "nav.signed_in_as": "ログイン中：",
  "nav.toggle_menu": "メニュー切替",
  "nav.toggle_theme": "テーマ切替",

  // Dashboard
  "dashboard.title": "マイリンク",
  "dashboard.search": "リンクを検索...",
  "dashboard.create_link": "リンク作成",
  "dashboard.loading": "リンクを読み込み中...",
  "dashboard.no_results": "一致するリンクがありません：",
  "dashboard.empty": "まだリンクがありません。最初の短縮リンクを作成しましょう！",
  "dashboard.clicks": "クリック",
  "dashboard.inactive": "無効",
  "dashboard.previous": "前へ",
  "dashboard.next": "次へ",
  "dashboard.page_of": "{page} / {total} ページ",
  "dashboard.copy_url": "短縮URLをコピー",

  // Create Link
  "create.title": "短縮リンクを作成",
  "create.url_label": "宛先URL *",
  "create.custom_slug": "カスタムURL",
  "create.slug_invalid": "英数字、ハイフン、アンダースコアのみ使用できます。",
  "create.slug_taken": "このスラッグは既に使用されています。",
  "create.slug_available": "このスラッグは利用可能です！",
  "create.slug_auto": "ランダムなスラッグが自動生成されます。",
  "create.title_label": "タイトル",
  "create.expires_label": "有効期限",
  "create.remove_expiration": "有効期限を削除",
  "create.preview": "プレビュー",
  "create.button": "短縮リンクを作成",
  "create.creating": "作成中...",
  "create.failed": "リンクの作成に失敗しました",
  "create.title_tooltip": "ダッシュボードでリンクを識別するための名前です。",
  "create.slug_tooltip": "ooo.codes/の後のパスをカスタマイズします。空欄の場合は自動生成されます。",
  "create.expires_tooltip": "この日付を過ぎるとリンクが無効になります。最大30日まで設定可能です。",
  "create.expires_max_30": "最大30日まで設定可能です。",

  // Link Detail
  "detail.loading": "読み込み中...",
  "detail.not_found": "リンクが見つかりません",
  "detail.back": "ダッシュボードに戻る",
  "detail.inactive": "無効",
  "detail.analytics": "分析",
  "detail.edit": "編集",
  "detail.cancel": "キャンセル",
  "detail.delete": "削除",
  "detail.confirm_delete": "本当に削除しますか？",
  "detail.yes_delete": "はい、削除",
  "detail.no": "いいえ",
  "detail.short_url": "短縮URL",
  "detail.destination": "宛先",
  "detail.clicks": "クリック数",
  "detail.created": "作成日",
  "detail.expires": "有効期限",
  "detail.status": "ステータス",
  "detail.active": "有効",
  "detail.edit_link": "リンクを編集",
  "detail.destination_url": "宛先URL",
  "detail.title_label": "タイトル",
  "detail.expires_at": "有効期限",
  "detail.remove_expiration": "有効期限を削除",
  "detail.active_toggle": "有効",
  "detail.save_changes": "変更を保存",
  "detail.saving": "保存中...",
  "detail.update_failed": "リンクの更新に失敗しました",
  "detail.copy_tooltip": "クリップボードにコピー",

  // Analytics
  "analytics.title": "分析",
  "analytics.loading": "分析データを読み込み中...",
  "analytics.no_data": "分析データがありません。",
  "analytics.last_7": "過去7日間",
  "analytics.last_30": "過去30日間",
  "analytics.last_90": "過去90日間",
  "analytics.total_clicks": "合計クリック",
  "analytics.today": "今日",
  "analytics.this_week": "今週",
  "analytics.this_month": "今月",
  "analytics.over_time": "時間別クリック数",
  "analytics.referrers": "上位リファラー",
  "analytics.countries": "上位国",
  "analytics.devices": "デバイス",
  "analytics.browsers": "ブラウザ",
  "analytics.empty": "まだクリックデータがありません。リンクを共有して分析を始めましょう。",

  // Settings
  "settings.title": "設定",
  "settings.account": "アカウント",
  "settings.username": "ユーザー名",
  "settings.display_name": "表示名",
  "settings.role": "役割",
  "settings.member_since": "登録日",
  "settings.api_keys": "APIキー",
  "settings.api_keys_desc": "ooo.codes APIにプログラムからアクセスするためのAPIキーを作成します。",
  "settings.key_placeholder": "キー名（例：CI/CDパイプライン）",
  "settings.create_key": "キー作成",
  "settings.key_created": "APIキーが作成されました！今すぐコピーしてください — 再度表示されません。",
  "settings.no_keys": "まだAPIキーがありません。",
  "settings.revoke": "取消",
  "settings.created": "作成日",
  "settings.last_used": "最終使用",
  "settings.invite_user": "ユーザーを招待",
  "settings.invite_desc": "アカウントを作成できるよう招待を送信します。",
  "settings.send_invite": "招待を送信",
  "settings.invite_created": "招待が作成されました！このリンクを共有してください：",
  "settings.create_key_failed": "APIキーの作成に失敗しました",
  "settings.revoke_failed": "キーの取消に失敗しました",
  "settings.invite_failed": "招待の送信に失敗しました",

  // QR Customizer
  "qr.title": "QRコード",
  "qr.foreground": "前景色",
  "qr.background": "背景色",
  "qr.size": "サイズ",
  "qr.error_correction": "誤り訂正",
  "qr.ec_low": "低",
  "qr.ec_med": "中",
  "qr.ec_high": "高",
  "qr.ec_max": "最大",
  "qr.ec_info": "高い訂正レベルでは、QRコードが部分的に損傷していてもスキャンできます。",
  "qr.save": "設定を保存",
  "qr.saving": "保存中...",
  "qr.saved": "保存しました！",

  // Admin
  "admin.title": "管理コンソール",
  "admin.dashboard": "ダッシュボード",
  "admin.users": "ユーザー管理",
  "admin.stats": "統計",
  "admin.total_users": "全ユーザー",
  "admin.active_users": "アクティブ",
  "admin.pending_users": "承認待ち",
  "admin.total_links": "全リンク",
  "admin.total_clicks": "全クリック",
  "admin.today_signups": "本日の登録",
  "admin.user_detail": "ユーザー詳細",
  "admin.status_pending": "保留",
  "admin.status_active": "アクティブ",
  "admin.status_suspended": "停止",
  "admin.status_banned": "ブロック",
  "admin.approve": "承認",
  "admin.reject": "拒否",
  "admin.suspend": "停止",
  "admin.ban": "ブロック",
  "admin.activate": "有効化",
  "admin.daily_limit": "日別リンク制限",
  "admin.daily_limit_unlimited": "無制限",
  "admin.links_today": "本日のリンク",
  "admin.status_reason": "理由",
  "admin.status_reason_placeholder": "停止/ブロックの理由を入力",
  "admin.confirm_suspend": "このユーザーを停止しますか？",
  "admin.confirm_ban": "このユーザーを永久ブロックしますか？",
  "admin.link_count": "リンク数",
  "admin.member_since": "登録日",
  "admin.role": "役割",
  "admin.status": "ステータス",
  "admin.actions": "管理",
  "admin.no_users": "ユーザーがいません。",
  "admin.all": "全て",
  "admin.filter_status": "ステータスフィルター",
  "admin.back": "一覧へ",
  "admin.save_limit": "保存",
  "admin.console": "管理",
  "admin.role_owner": "オーナー",
  "admin.role_member": "メンバー",
  "admin.change_role": "役割変更",
  "admin.confirm_role_change": "このユーザーの役割を変更しますか？",
};
